
import React, {Component} from 'react'
import {Modal} from 'react-bootstrap'

import DepositDoc from './DepositDoc'
import DepositFromWorkRecordModel from './DepositFromWorkRecordModel'
import DPDocStore  from '../../stores/DPDocStore';
class DepositDocModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {showRec:false,showDoc:false,list:[]}
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadRecord()
    }
  }

  loadRecord(){
    DPDocStore.loadWorkRecord(this.props.workNo,(result)=>{
      if(result.data.list.length>0){
        this.setState({showRec:true,showDoc:false,list:result.data.list})
      }else{        
        this.onNewDoc()
      }
    },()=>{

    })
    
  }

  onSelectItem(item){
    
    this.setState({showRec:false,showDoc:true})
    setTimeout(()=>{
      this.loadData(item.deposit_no)
    },100)
  }

  onNewDoc(){

    this.setState({showRec:false,showDoc:true})
    setTimeout(()=>{
        this.loadNewDocFromWork(this.props.workNo,{});
      },100)
    
  }

  loadData(dpNo){
    this.refs.dpDocW.getWrappedInstance().loadData(dpNo)
  }

  loadNewDocFromWork(workNo,item){
    this.refs.dpDocW.getWrappedInstance().loadNewDocFromWork(workNo,item)
  }

  render(){
    let {show} = this.props
    let {showRec,showDoc} = this.state
    return (
      <div>
        <DepositFromWorkRecordModel show={showRec} 
        list={this.state.list}
        onHide={()=>{this.setState({showRec:false});this.props.onHide();}}
        onSelectItem={this.onSelectItem.bind(this)}
        onNewDoc={this.onNewDoc.bind(this)}
        />
        <Modal show={showDoc && show} enforceFocus={false} 
          onHide={()=>{this.setState({showRec:false}); this.props.onHide();}} dialogClassName="fullwidth-dialog">
          <Modal.Body>
                <DepositDoc ref='dpDocW' onSaved={this.props.onSaved} onClose={this.props.onHide}/>
          </Modal.Body>        
        </Modal>  
      </div>
    )
  }
}

DepositDocModal.defaultProps = {
  show : false,
  workNo:''
}


export default DepositDocModal;








// WEBPACK FOOTER //
// ./src/view/so/DepositDocModal.js